module.exports = __webpack_public_path__ + "static/img/person.302597b5.svg";